import {
  FaStar,
  FaUserCircle,
} from "react-icons/fa";

import "./ProviderReviewSection.css";

export default function ProviderReviewSection({
  reviews = [],
  stats = {},
}) {
  return (
    <section className="provider-review-section">

      <div className="review-header">

        <h2>
          Customer Reviews
        </h2>

        <div className="review-summary">

          <div className="summary-rating">

            <FaStar />

            <span>
              {stats.averageRating || 0}
            </span>

          </div>

          <p>
            {stats.totalReviews || 0} Reviews
          </p>

        </div>

      </div>

      {reviews.length === 0 ? (
        <div className="no-reviews">

          <FaUserCircle />

          <h3>No Reviews Yet</h3>

          <p>
            Be the first customer to review this provider.
          </p>

        </div>
      ) : (
        <div className="review-list">

          {reviews.map((review) => (

            <div
              className="review-card"
              key={review._id}
            >

              <div className="review-top">

                <div className="review-user">

                  <FaUserCircle />

                  <div>

                    <h4>
                      {review.customerName ||
                        "Customer"}
                    </h4>

                    <small>
                      {review.createdAt
                        ? new Date(
                            review.createdAt
                          ).toLocaleDateString()
                        : ""}
                    </small>

                  </div>

                </div>

                <div className="review-stars">

                  <FaStar />

                  <span>
                    {review.rating}
                  </span>

                </div>

              </div>

              <p className="review-comment">

                {review.comment}

              </p>

            </div>

          ))}

        </div>
      )}

    </section>
  );
}